export default __webpack_public_path__ + "static/banzai_logo_splash-3aea51c5a39ebf1e66f65379dde05fbb.svg";